import { IntlShape } from 'react-intl'
import * as yup from 'yup'
import { POSTAL_CODE_REGEXP } from 'lib/core/resources/constants'
import { PO_BOX_REGEX } from 'resources/constants'

export interface AddressValidationDeps {
  intl?: IntlShape
  countryCode?: string
  postalCodeIsOptional?: boolean
  regionIsRequired?: boolean
}

export const addressValidation = ({
  intl,
  countryCode,
  postalCodeIsOptional,
  regionIsRequired = true // TODO: this should be changed to false or just remove the `true`. Currently `true` for backwards compatibility.
}: AddressValidationDeps = {}) => {
  const formatMessage = intl?.formatMessage
  const postalCodeRegex = POSTAL_CODE_REGEXP[countryCode ?? ''] ?? null

  return (
    yup
      .object()
      .shape({
        firstName: yup
          .string()
          .required(formatMessage ? formatMessage({ id: 'validation.firstNameRequired' }) : ''),

        lastName: yup
          .string()
          .required(formatMessage ? formatMessage({ id: 'validation.lastNameRequired' }) : ''),

        countryCode: yup
          .string()
          .required(formatMessage ? formatMessage({ id: 'validation.countryRequired' }) : ''),

        regionCode: regionIsRequired
          ? yup
            .string()
            .required(formatMessage ? formatMessage({ id: 'validation.stateRequired' }) : '')
          : yup.string(),

        city: yup
          .string()
          .required(formatMessage ? formatMessage({ id: 'validation.cityRequired' }) : ''),

        postalCode: postalCodeIsOptional
          ? yup.string()
          : postalCodeRegex
            ? (yup
              .string()
              .matches(postalCodeRegex, formatMessage ? formatMessage({ id: 'validation.postalCodeRequired' }) : '')
              .required(formatMessage ? formatMessage({ id: 'validation.postalCodeRequired' }) : ''))
            : (yup
              .string()
              .required(formatMessage ? formatMessage({ id: 'validation.postalCodeRequired' }) : '')),

        street: yup
          .string()
          .matches(PO_BOX_REGEX, formatMessage ? formatMessage({ id: 'validation.PoBox.invalid' }) : '')
          .required(formatMessage ? formatMessage({ id: 'validation.streetRequired' }) : ''),

        street2: yup
          .string()
          .matches(PO_BOX_REGEX, formatMessage ? formatMessage({ id: 'validation.PoBox.invalid' }) : ''),

        phoneNumber: yup
          .string()
          .required(formatMessage ? formatMessage({ id: 'validation.phoneNumberRequired' }) : '')
      })
  )
}
